import { forwardRef, type Ref, type SVGProps } from "react";
const IconLightBulbFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16.05 2a9.77 9.77 0 0 0-9.85 9.46A9.31 9.31 0 0 0 11 19.6V23a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.39a9.19 9.19 0 0 0 4.8-8.15A9.61 9.61 0 0 0 16.05 2"
    />
    <rect width={10} height={2} x={11} y={25} fill="currentColor" rx={1} />
    <rect width={8} height={2} x={12} y={28} fill="currentColor" rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconLightBulbFilledSVG);
ForwardRef.displayName = "IconLightBulbFilled";
export { ForwardRef as IconLightBulbFilled };
